export default __webpack_public_path__ + "static/media/keg-euro.c9098413.png";